import fileDownload from 'downloadjs';
import { AUTH_TOKEN } from '../../constants/projectConstants';
import { errorToast, infoToast } from '../../helpers/toastHelper';
import { downloadFailed, startDownload, updateDownload } from './DownloadFileContext';

let xhrInstance;

// export const getFileNameFromUrl = (url, isMap) => {
//   if (!url) return '';
  
//   const urlParser = new URL(url);
//   const tempFileName = urlParser.pathname.split('/').reverse()[0]
//   console.log(tempFileName, 'tempFileName 1')
//   if (tempFileName.includes('.')) {
//     console.log(tempFileName, 'tempFileName 2')
//     return tempFileName
//   }
// }

export const getFileNameFromUrl = (url, isMap = false) => {
  if (!url) return '';

  try {
    const urlParser = new URL(url);
    const tempFileName = urlParser.pathname.split('/').pop() || '';

    if (tempFileName.includes('.')) {
      if (isMap) {
        const dotIndex = tempFileName.lastIndexOf('.');
        const namePart = tempFileName.substring(0, dotIndex); // "texture_squares"
        const ext = tempFileName.substring(dotIndex);          // ".jpg"

        // Check for underscore
        const underscoreIndex = namePart.indexOf('_');

        let newName;
        if (underscoreIndex !== -1) {
          // Replace base before underscore with customMap, keep rest
          const suffix = namePart.substring(underscoreIndex); // "_squares"
          newName = `customMap${suffix}${ext}`;               // "customMap_squares.jpg"
        } else {
          // No underscore, just replace entire base name with customMap
          newName = `customMap${ext}`;                         // "customMap.jpg"
        }
        return newName;
      }
      
      return tempFileName;
    }

    return '';
  } catch (err) {
    console.error('Invalid URL in getFileNameFromUrl:', url, err);
    return '';
  }
};


export const trackDownloadingOnXHR = async ({
  url,
  fileName,
  onProgress,
  sectinoId,
  sectionName,
  auth,
  // onSuccess,
  // onError,
}) =>
  new Promise((resolve, reject) => {
    const fileId = `${url}${Date.now()}`;
    const sId = sectinoId || 'DEFAULT';

    if (!fileName) {
      fileName = getFileNameFromUrl(url)
    }

    startDownload(
      {
        id: fileId,
        downloadedBytes: 0,
        fileSizeBytes: -1,
        fileName,
        sectionId: sId,
      },
      sectionName
    );

    const xhr = new XMLHttpRequest();
    xhrInstance = xhr;
    xhr.open('GET', url);
    xhr.responseType = 'blob';

    if (auth) {
      const token = localStorage.getItem(AUTH_TOKEN);
      xhr.setRequestHeader('Authorization', `Bearer ${token}`)
    }


    xhr.onprogress = (event) => {
      onProgress?.(event);

      updateDownload(sId, fileId, {
        downloadedBytes: event.loaded,
        fileSizeBytes: event.total,
      });
    };

    xhr.onload = (e) => {
      if (xhr.status !== 200) {
        // TODO: download failed
        downloadFailed(sId, fileId, {})
        errorToast(`Download of ${`"${fileName}"` || 'file'} failed`)
        reject();
      } else {
        resolve(e);
        // const response = JSON.parse(xhr.response);
        // console.log(response[0].author.login);
      }
    };

    xhr.send();
  });

export function cancelDownload() {
  if (xhrInstance){
    xhrInstance.abort();
  }
}

export const download = async ({
  fileUrl,
  fileName,
  fileType,
  sectinoId,
  sectionName,
  auth,
  throwOnError = false,
  callback = null,
  infoMessage,
  isMap = false
}) => {
  let blob;

  try {
    const result = await trackDownloadingOnXHR({
      url: fileUrl,
      fileName,
      sectinoId,
      sectionName,
      auth,
    });

    blob = result.currentTarget.response;
    callback?.()
  } catch (e) {
    if (throwOnError) {
      throw e;
    } else {
      return;
    }
  }

  if (!fileName) {
    fileName = getFileNameFromUrl(fileUrl, isMap)
  }

  // const response = await fetch(fileUrl);
  // const blob = await response.blob();

  fileDownload(blob, fileName, fileType);
  
  if (infoMessage) {
    infoToast(infoMessage);
  }
};
